module.exports = __webpack_public_path__ + "app/layouts/content-layout-vZ5COANH.html";